import React from 'react';

const WaitSpinner = () => (
  <div id="WaitSpinner">
    <div id="spinner" />
  </div>
);

export default WaitSpinner;
